/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListActivities200ResponseMetaLinksInner
 */
export interface ListActivities200ResponseMetaLinksInner {
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseMetaLinksInner
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseMetaLinksInner
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ListActivities200ResponseMetaLinksInner
     */
    page?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ListActivities200ResponseMetaLinksInner
     */
    active?: boolean;
}

/**
 * Check if a given object implements the ListActivities200ResponseMetaLinksInner interface.
 */
export function instanceOfListActivities200ResponseMetaLinksInner(value: object): value is ListActivities200ResponseMetaLinksInner {
    return true;
}

export function ListActivities200ResponseMetaLinksInnerFromJSON(json: any): ListActivities200ResponseMetaLinksInner {
    return ListActivities200ResponseMetaLinksInnerFromJSONTyped(json, false);
}

export function ListActivities200ResponseMetaLinksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListActivities200ResponseMetaLinksInner {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'] == null ? undefined : json['url'],
        'label': json['label'] == null ? undefined : json['label'],
        'page': json['page'] == null ? undefined : json['page'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function ListActivities200ResponseMetaLinksInnerToJSON(json: any): ListActivities200ResponseMetaLinksInner {
    return ListActivities200ResponseMetaLinksInnerToJSONTyped(json, false);
}

export function ListActivities200ResponseMetaLinksInnerToJSONTyped(value?: ListActivities200ResponseMetaLinksInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'label': value['label'],
        'page': value['page'],
        'active': value['active'],
    };
}

